import { SVGProps } from 'react';

export const ThreadsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1829_8653)">
        <path
          d="M14.5392 16.8353C14.0475 17.143 13.7642 17.5455 13.6972 18.031C13.6117 18.6518 13.8812 19.0875 14.1227 19.3435C14.621 19.8725 15.4682 20.1458 16.3855 20.074C18.4697 19.9118 19.121 18.2028 19.2552 16.5505C18.471 16.3485 17.7067 16.248 17.0045 16.248C16.023 16.248 15.1632 16.4443 14.5392 16.8353Z"
          fill="black"
        />
        <path
          d="M29.3465 2.67024C27.25 0.567993 23.4902 0.567993 16 0.567993C8.50599 0.567993 4.74449 0.567993 2.65399 2.66074C0.567993 4.74899 0.567993 8.50899 0.567993 16C0.567993 23.4825 0.567993 27.238 2.67624 29.3405C4.77349 31.4317 8.52524 31.4317 16 31.4317C23.471 31.4317 27.221 31.4317 29.3242 29.3307C31.432 27.2255 31.432 23.474 31.432 16C31.432 8.51724 31.432 4.76149 29.3465 2.67024ZM8.03974 16.7045C8.12099 19.3622 9.07274 25.544 16.1412 25.544C20.0212 25.544 22.947 23.4335 22.947 20.6342C22.947 19.0375 22.4197 18.0012 21.1805 17.2882C20.7622 20.1147 19.0935 21.8687 16.5407 22.0677C15.0007 22.1862 13.59 21.6942 12.6672 20.7147C11.9027 19.9035 11.565 18.8532 11.7162 17.7572C11.8657 16.6727 12.475 15.7677 13.478 15.1397C14.8987 14.25 16.9605 14.0227 19.1712 14.4782C18.7697 12.308 17.3795 11.8767 16.497 11.831C14.4047 11.7237 13.6497 12.9982 13.6187 13.0527L11.8587 12.103C11.9117 12.0032 13.2025 9.65674 16.6005 9.83374C18.7332 9.94449 21.0035 11.4015 21.2597 15.109C23.739 16.1405 24.947 17.9547 24.947 20.6342C24.947 24.5735 21.1612 27.544 16.1412 27.544C10.0225 27.544 6.24674 23.5147 6.04074 16.7655C5.91399 12.617 6.93674 9.30024 8.99899 7.17424C10.7487 5.37024 13.1805 4.45549 16.227 4.45549C23.547 4.45549 25.5125 10.0377 25.9405 11.7487L24 12.234C23.5655 10.4965 21.938 6.45549 16.227 6.45549C13.7422 6.45549 11.7935 7.16574 10.4347 8.56649C8.31649 10.7505 7.96324 14.1975 8.03974 16.7045Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1829_8653">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
